import React from 'react';
import {styles} from './iconGroup_styles.web';
import {IconGroupProps} from './iconGroup_types.web';
import Tooltip from '../../Tooltips/Tooltip/Tooltip.web';

const IconGroup = (props: React.PropsWithChildren<IconGroupProps>) => {
  // Props
  const {id, className, iconList, containerStyle} = props;

  return (
    <div
      id={id}
      className={className}
      style={{...styles.iconGroupContainer, ...containerStyle}}>
      {iconList?.length
        ? iconList?.map((item: any, index) => {
            return (
              <div
                key={index}
                onClick={item?.onClick}
                style={{cursor: 'pointer'}}>
                {item?.tooltip ? (
                  <Tooltip {...item?.tooltip}>
                    <item.Icon
                      style={item?.style || 'outline'}
                      size={item?.size || '24'}
                      color={item?.color}
                    />
                  </Tooltip>
                ) : (
                  <item.Icon
                    style={item?.style || 'outline'}
                    size={item?.size || '24'}
                    color={item?.color}
                  />
                )}
              </div>
            );
          })
        : null}
    </div>
  );
};

export default IconGroup;
